import { checkoutData } from './checkout'

export function createSession (data, sentry) {
  // check if is only theft insurance
  const insuranceTypeList = data.somenteRoubo
    ? ['theftPrice', 'theftPaymentOptions']
    : ['completePrice', 'completePaymentOptions']

  // check if has protected bag
  const amount = data.protectedBag
    ? data.protectedBag[insuranceTypeList[0]]
    : data.device[insuranceTypeList[0]]

  const price = data.protectedBag
    ? data.protectedBag[insuranceTypeList[1]][data.protectedBag[insuranceTypeList[1]].length - 1]
    : data.device[insuranceTypeList[1]][data.device[insuranceTypeList[1]].length - 1]

  const installments = data.protectedBag
    ? data.protectedBag[insuranceTypeList[1]]
    : data.device[insuranceTypeList[1]]

  // data that checkout uses to mount the screen
  checkoutData(
    {
      ...data,
      nome: data.device.name,
      deviceTypeName: data.device.deviceTypeName || null,
      parcela: data.precoPromo.length,
      parcelasPrecos: installments,
      scorePoints: data.scorePoints,
      preco: price,
      precoTotal: amount
    },
    sentry
  )

  // data that the app uses to mount the success screen
  sessionStorage.setItem(
    'ciclic:device',
    JSON.stringify({
      nome: data.device.name,
      deviceTypeName: data.device.deviceTypeName
        ? data.device.deviceTypeName.toLowerCase()
        : null,
      parcela: data.parcela,
      parcelasPrecos: installments,
      uuid: data.uuid,
      somenteRoubo: data.somenteRoubo,
      scoringProgram: {
        pointsLivelo: data.isPartnerLivelo
          ? data.scorePoints
          : null,
        pointsDotz: data.isPartnerDotz
          ? data.scorePoints
          : null
      },
      ...(data.protectedBag && {
        protectedBag: data.protectedBag
      })
    })
  )

  // set quotedDevice data to persists the session when user backs from checkout
  sessionStorage.setItem(
    'ciclic:quotedDevice',
    JSON.stringify(data)
  )

  sessionStorage.removeItem('coupon')
}
